import React from 'react';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { JiraPriorityData } from '../../../../api/endpoints/jira';
import { CommandDispatcher } from '../../../../concepts/commands/CommandDispatcher';
import { useLoader2 } from '../../../../platform/Hook';
import { Menu } from '../../../../ui';
import { useResolve } from '../../../Container';
import { UIField } from '../../../canvas/entities/UIField';
import { PopperFieldEditor, PopperFieldEditorContentProps } from '../../../canvas/workspace/adapters/PopperFieldEditor';
import { jiraCardSetPriority } from '../AtlassianCommands';
import { JiraCard } from '../JiraCard';
import { JiraOAuthRequiredPopperContent } from './JiraOAuthRequiredPopperContent';
import { JiraPopperActionMenu } from './JiraPopperActionMenu';

export const JiraPriorityMenu = ({ cards, onClose }: { cards: JiraCard[], onClose(): void }) => {

    const api = useResolve(ApiClient);
    const dispatch = useResolve(CommandDispatcher);

    const mainCard = cards[0];
    const [loading, fields] = useLoader2(() => api.exec(v2.jira.issues.fields(mainCard.key)), [mainCard]);

    const onClick = (tm: JiraPriorityData) => {
        dispatch(jiraCardSetPriority, [tm, cards.map(x => x.id)]);
        onClose();
    };

    return <JiraPopperActionMenu loading={loading} label="Set Priority">
        {fields?.priority?.allowedValues?.map((tm, i) =>
            <Menu.Item role="menuitem" aria-label={tm.name} key={i} onClick={() => onClick(tm)}>
                <img style={{ width: '1.5rem' }} src={tm.iconUrl} />
                <Menu.ItemText>{tm.name}</Menu.ItemText>
            </Menu.Item>
        )}
    </JiraPopperActionMenu>;
};

const JiraPriorityMenuFieldEditor = ({ field, onClose }: PopperFieldEditorContentProps) =>
    <JiraPriorityMenu cards={[field.owner.cast(JiraCard)]} onClose={onClose} />;

export const JiraPriorityField = (owner: JiraCard): UIField => ({
    ui: PopperFieldEditor(JiraOAuthRequiredPopperContent(JiraPriorityMenuFieldEditor)),
    owner,
    name: 'priority',
    bounds: owner.layout.priority,
});

